import { apolloClient } from '@/vue-apollo'
import { Preferences } from '@capacitor/preferences'
import gql from 'graphql-tag'
import { defineStore } from 'pinia'
import { CREATE_MYSHELVES, DELETE_MYSHELVES, MYSHELF, MYSHELVES } from '../graphql_queries';



export const useShelfStore = defineStore('shelfStore', {
  state: ()=> ({
    isLoading: false,
    error: null,
    shelf: <any>{

    },
    shelves: <any>[]
  }),
  actions: {
    async axShelves(userId: string, searchVal?: string) {
  
      const response = await apolloClient.query({
        variables: {
            userId,
            searchVal
          },
        query: MYSHELVES,
        fetchPolicy: 'network-only',
      })

      if (response.data.shelves) {
        this.shelves = response.data.shelves
        return true
      } else {
        this.shelves = [];
        return false
      }
    },

    async axShelf(id: any) {
        this.isLoading = true;
        const response = await apolloClient.query({
          variables: {
            id,
          },
          query: MYSHELF,
          fetchPolicy: 'network-only',
        })
  
        if (response.data.userShelf) {
          this.shelf = response.data.product;
          this.isLoading = false;
          return true
        } else {
          this.shelf = null;
          this.isLoading = false;
          return false
        }
    },

    async axCreateShelf(data: any) {
        this.isLoading = true;
        try {
          const response = await apolloClient.mutate({
            variables: {
              data,
            },
            mutation: CREATE_MYSHELVES,
            fetchPolicy: 'network-only',
          })
    
          console.log('resCreateShelf===>', response.data.createUserShelf)
          if (response.data.createUserShelf.id) {
            this.isLoading = false;
            return true
          } else {
            this.isLoading = false;
            return false
          }
        } catch (error) {
          this.isLoading = false;
          return false;
        }
    },

    async axDeleteShelves(data: any) {
      this.isLoading = true;
      try {
        const response = await apolloClient.mutate({
          variables: {
            data,
          },
          mutation: DELETE_MYSHELVES,
          fetchPolicy: 'network-only',
        })
  
        console.log('resDeleteShelves===>', response.data.deleteUserShelves)
        if (response.data.deleteUserShelves === "success") {
          this.isLoading = false;
          return true
        } else {
          this.isLoading = false;
          return false
        }
      } catch (error) {
        this.isLoading = false;
        return false;
      }
    },
  },

  getters: {
    
  }
});
